import { useState } from "react";
import { adminLogin, ApiError } from "./adminApi";
import { Button } from "../components/Button";

/**
 * Password gate for the admin panel. Shown only in API mode when whoami()
 * returns null (no valid JWT cookie). Posts to /api/admin/login which sets
 * an httpOnly cookie on success.
 */
export default function AdminLogin({ onSuccess }: { onSuccess: () => void }) {
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function submit(e?: React.FormEvent) {
    e?.preventDefault();
    if (!password) return;
    setBusy(true);
    setError(null);
    try {
      await adminLogin(password);
      onSuccess();
    } catch (err) {
      if (err instanceof ApiError && err.status === 401) {
        setError("Невірний пароль");
      } else if (err instanceof ApiError) {
        setError(`Помилка: ${err.status}`);
      } else {
        setError(`Не вдалося звʼязатися з сервером. Перевір що npm run server:dev запущений.`);
      }
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="pp-screen px-5 bg-[#0b0b14] flex items-center justify-center">
      <form
        onSubmit={submit}
        className="w-full max-w-sm flex flex-col gap-4 bg-white/5 border border-white/10 rounded-2xl p-6"
      >
        <h2 className="font-display text-2xl font-black text-center">
          🔐 Вхід в адмінку
        </h2>
        <p className="text-xs opacity-70 text-center">
          Тільки для адміністратора. Пароль зберігається у твоєму браузері
          (httpOnly cookie, 30 днів).
        </p>
        <input
          type="password"
          autoFocus
          placeholder="Пароль"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          className="w-full rounded-lg bg-white/10 border border-white/20 px-4 py-3 text-base focus:outline-none focus:border-white/50"
        />
        {error && (
          <div className="text-sm text-red-300 bg-red-500/15 border border-red-400/30 rounded-lg px-3 py-2">
            {error}
          </div>
        )}
        <Button variant="primary" fullWidth onClick={() => void submit()}>
          {busy ? "..." : "Увійти"}
        </Button>
      </form>
    </div>
  );
}
